<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M6.05 7.7501L6.9 19.6501H17.1L17.95 7.7501M6.05 7.7501H3.5M6.05 7.7501H8.6M17.95 7.7501H20.5M17.95 7.7501H15.4M15.4 7.7501V4.3501H8.6V7.7501M15.4 7.7501H8.6"
      stroke="currentColor"
      stroke-width="1.5"
    />
  </svg>
</template>
